<mat-dialog-content>
  <form [formGroup]="carparkFormGrp" #formRef="ngForm">
    <div
      class="dialog"
      *ngFor="let obj of unitList; let i = index"
      fxLayout="row"
      fxLayoutAlign="space-around center"
    >
      <div fxFlex="30">
        <mat-label>Unit</mat-label>
        <div>{{ obj.title }}</div>
      </div>

      <div class="right">
        <mat-form-field>
          <mat-chip-list #chipList aria-label="Car Park selection">
            <mat-chip
              multiple
              *ngFor="let cp of obj.carPark"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeCarPark(cp)"
            >
              {{cp.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="Select Car Park.."
              #carParkInput
              [formControl]="carParkCtrl"
              [matAutocomplete]="carpark"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCarPark($event)"
              required
            />
          </mat-chip-list>
          <mat-autocomplete
            #carpark="matAutocomplete"
            (optionSelected)="selectedCarPark($event,i)"
          >
            <mat-option
              *ngFor="let carpark of filteredCarPark;"
              [value]="carpark"
            >
              {{carpark.unitNo}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<div class="dialog-buttons">
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="cancel()"
  >
    Cancel
  </button>
  <button (click)="save()" mat-button color="primary">Save</button>
</div>
